/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Funnel_Sq_Fr1_BodyInputs */

const en_funnel_sq_fr1_body = /** @type {(inputs: Funnel_Sq_Fr1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Papers, textbooks, and PDFs, read aloud in a real, human voice, with every citation, reference, and footnote skipped for you. Clear your reading list on the walk to campus, at the gym, or between classes.`)
};

const es_funnel_sq_fr1_body = /** @type {(inputs: Funnel_Sq_Fr1_BodyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Artículos, libros de texto y PDF leídos en voz alta con una voz real y humana, omitiendo por ti cada cita, referencia y nota al pie. Despeja tu lista de lectura camino al campus, en el gimnasio o entre clases.`)
};

/**
* | output |
* | --- |
* | "Papers, textbooks, and PDFs, read aloud in a real, human voice, with every citation, reference, and footnote skipped for you. Clear your reading list on the ..." |
*
* @param {Funnel_Sq_Fr1_BodyInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const funnel_sq_fr1_body = /** @type {((inputs?: Funnel_Sq_Fr1_BodyInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Funnel_Sq_Fr1_BodyInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_funnel_sq_fr1_body(inputs)
	return en_funnel_sq_fr1_body(inputs)
});